function toSearchParams(routeQuery) {
  const source = typeof routeQuery === 'string'
    ? routeQuery
    : routeQuery?.toString?.() || '';
  return new URLSearchParams(source.startsWith('?') ? source.slice(1) : source);
}

function toCatalogUrl(query) {
  const serialized = query.toString();
  return `/catalog${serialized ? `?${serialized}` : ''}`;
}

export function buildSearchUrl(routeQuery, term) {
  const query = toSearchParams(routeQuery);
  const normalizedTerm = String(term ?? '').trim();
  if (normalizedTerm) query.set('search', normalizedTerm);
  else query.delete('search');
  return toCatalogUrl(query);
}

export function buildSearchSubmitUrl(routeQuery, term, legacyCategorySlug = '') {
  const normalizedTerm = String(term ?? '').trim();
  if (normalizedTerm) return buildSearchUrl(routeQuery, normalizedTerm);

  const query = toSearchParams(routeQuery);
  query.delete('search');
  const pathname = !query.has('aslCategory') && legacyCategorySlug
    ? `/catalog/${legacyCategorySlug}`
    : '/catalog';
  const serialized = query.toString();
  return `${pathname}${serialized ? `?${serialized}` : ''}`;
}

export function buildCanonicalAslUrl(routeQuery, key) {
  const query = toSearchParams(routeQuery);
  query.delete('aslCategory');
  if (key) query.set('aslCategory', key);
  return toCatalogUrl(query);
}
